import { FireOffIcon } from './FireOffIcon';

/**
 * author: Michael Irigoyen
 * id DAB67757-2065-4741-A03A-563D0EA202E0
 * name fire-off
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/fire-off.svg
 * tags
 * - Home Automation 
 */
export const FlameOffIcon = FireOffIcon;
export default FlameOffIcon